/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';
import {QuestionnaireResponseAnswerModel} from "../../models/questionnaire-response-answer-model";

export interface AnalyticsResponseAnswersGetParams {
    questionnaireInstanceGuid: string;
}

export function analyticsResponseAnswersGet(http: HttpClient, rootUrl: string, params: AnalyticsResponseAnswersGetParams, headers: HttpHeaders, context?: HttpContext): Observable<StrictHttpResponse<QuestionnaireResponseAnswerModel[]>> {
    const rb = new RequestBuilder(rootUrl, analyticsResponseAnswersGet.PATH, 'get');
    for (let headerKey of headers.keys()) {
        rb.header(headerKey, headers.get(headerKey));
    }
    if (params) {
        rb.path('questionnaireInstanceGuid', params.questionnaireInstanceGuid, {"style":"simple"});
    }
    return http.request(
        rb.build({ responseType: 'json', accept: '*/*', context })
    ).pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
            return r as StrictHttpResponse<QuestionnaireResponseAnswerModel[]>;
        })
    );
}

analyticsResponseAnswersGet.PATH = '/api/v1/analytics/responses/{questionnaireInstanceGuid}/answers';
